import { render, staticRenderFns } from "./CardCopy.vue?vue&type=template&id=2ca4d2ca&scoped=true&"
import script from "./CardCopy.vue?vue&type=script&lang=ts&"
export * from "./CardCopy.vue?vue&type=script&lang=ts&"
import style0 from "./CardCopy.vue?vue&type=style&index=0&id=2ca4d2ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca4d2ca",
  null
  
)

export default component.exports